import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { TariffsModuleService } from '../proxy/controlling/controllers/tariffs-module.service';

FieldBuilder.setNamespace('Controlling');

export const ROUTECORRIDOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RouteCorridor.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.RouteCorridor.Code')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder.foreignKey(
    'tariffsModuleId',
    'Entity.TariffsModule',
    TariffsModuleService
  )
    .displayFromNested('tariffsModule.name')
    .sortBy('tariffsModule.name')
    .build(),
];

export const ROUTECORRIDOR_CONFIG = {
  entityName: 'RouteCorridor',
  localizationKey: 'Controlling::Entity.RouteCorridor',
  fields: ROUTECORRIDOR_FIELDS,
  permission: 'ControllingLiquidations.RouteCorridors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
